export const visit = (vm, at) => {
at({ "pl": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Brak b\u0142\u0119d\xF3w po\u0142\u0105czenia z sieci\u0105.", "message": "Sprawd\u017A po\u0142\u0105czenie i spr\xF3buj ponownie.", "button": "Spr\xF3buj ponownie" } } } } });
};